import React, { useEffect, useState } from 'react';
import { userAPI, questionAPI, boardAPI } from '../../../api';
import { useAuthStore } from '../../../store';
import '../../admin/Admin.css';

const AdminDashboard: React.FC = () => {
  const { user } = useAuthStore();
  const [stats, setStats] = useState({
    totalUsers: 0, pendingUsers: 0,
    totalSubjects: 0, pendingSuggestions: 0,
  });
  const [recentUsers, setRecentUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const [userRes, subjectRes, sugRes] = await Promise.all([
        userAPI.list(),
        questionAPI.adminSubjects(),
        boardAPI.suggestions(),
      ]);
      const users = userRes.data;
      const suggestions = sugRes.data;
      setStats({
        totalUsers: users.length,
        pendingUsers: users.filter((u: any) => u.status === 'pending').length,
        totalSubjects: subjectRes.data.length,
        pendingSuggestions: suggestions.filter((s: any) => s.status === 'pending').length,
      });
      setRecentUsers(users.slice(0, 10));
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const updateStatus = async (userId: number, status: string) => {
    try {
      await userAPI.updateStatus(userId, status);
      await load();
    } catch (e) { alert('처리 실패'); }
  };

  const deleteUser = async (userId: number) => {
    if (!window.confirm('이 회원을 삭제하시겠습니까?')) return;
    try {
      await userAPI.delete(userId);
      await load();
    } catch (e) { alert('삭제 실패'); }
  };

  const statCards = [
    { label: '전체 회원', value: stats.totalUsers, icon: '👥', color: '#dbeafe', textColor: '#1d4ed8' },
    { label: '승인 대기', value: stats.pendingUsers, icon: '⏳', color: '#fef3c7', textColor: '#b45309' },
    { label: '종목 수', value: stats.totalSubjects, icon: '📚', color: '#dcfce7', textColor: '#15803d' },
    { label: '미확인 건의', value: stats.pendingSuggestions, icon: '📨', color: '#fce7f3', textColor: '#be185d' },
  ];

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title">
          <span className="icon">📊</span>대시보드
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          안녕하세요, {user?.username}님 👋
        </div>
      </div>

      {/* 통계 카드 */}
      <div className="admin-stats-grid">
        {statCards.map((card, i) => (
          <div key={i} className="admin-stat-card" style={{ background: card.color, border: 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ fontSize: 32, lineHeight: 1 }}>{card.icon}</div>
              <div>
                <div className="admin-stat-value" style={{ color: card.textColor, fontSize: 24, marginBottom: 2 }}>{card.value}</div>
                <div className="admin-stat-label" style={{ color: card.textColor, opacity: 0.8 }}>{card.label}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 최근 가입 회원 */}
      <div className="card">
        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>최근 가입 회원</span>
          {stats.pendingUsers > 0 && (
            <span className="badge badge-warning">대기 {stats.pendingUsers}명</span>
          )}
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          {loading ? (
            <div className="loading-spinner"><div className="spinner" /></div>
          ) : recentUsers.length === 0 ? (
            <div className="empty-state"><p>가입된 회원이 없습니다.</p></div>
          ) : (
            <div className="table-wrap">
              <table className="table">
                <thead>
                  <tr>
                    <th>아이디</th>
                    <th>이메일</th>
                    <th>가입일</th>
                    <th>상태</th>
                    <th style={{ width: 200 }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {recentUsers.map((u: any) => (
                    <tr key={u.id} style={{ background: u.status === 'pending' ? '#fffbeb' : '' }}>
                      <td style={{ fontWeight: 600 }}>{u.username}</td>
                      <td style={{ color: 'var(--text-muted)' }}>{u.email || '-'}</td>
                      <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>
                        {u.created_at?.slice(0, 10)}
                      </td>
                      <td>
                        <span className={`badge ${
                          u.status === 'approved' ? 'badge-success' :
                          u.status === 'rejected' ? 'badge-danger' : 'badge-warning'
                        }`}>
                          {u.status === 'approved' ? '✓ 승인' : u.status === 'rejected' ? '✗ 거부' : '⏳ 대기'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          {u.status !== 'approved' && (
                            <button className="btn btn-success btn-sm"
                              onClick={() => updateStatus(u.id, 'approved')}>승인</button>
                          )}
                          {u.status === 'approved' && (
                            <button className="btn btn-warning btn-sm"
                              onClick={() => updateStatus(u.id, 'pending')}>취소</button>
                          )}
                          {u.status !== 'rejected' && (
                            <button className="btn btn-ghost btn-sm"
                              onClick={() => updateStatus(u.id, 'rejected')}>거부</button>
                          )}
                          <button className="btn btn-danger btn-sm"
                            onClick={() => deleteUser(u.id)}>삭제</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
